import { createStore } from 'redux';
import kjuicer, { initialState } from './store/reducer';
import Viewer from './components/viewer/';
// import Controller from './components/controller/';
import Layer from './components/layer/';
import * as actionCreator from './store/actions';
import pluginFactory from './plugins/index.ts';
import './index.css';

function devtools() {
  if (window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== 'production') { // eslint-disable-line no-underscore-dangle
    return window.__REDUX_DEVTOOLS_EXTENSION__(); // eslint-disable-line no-underscore-dangle
  }

  return _ => _;
}

export default class App {
  constructor(target, config = {}) {
    this.html = (typeof target === 'string') ? document.getElementById(target) : target;
    if (config.render) {
      fetch(config.render)
        .then(res => res.json())
        .then((obj) => {
          this.setup({
            html: obj.content,
            plugins: [],
            ...config,
          });
        });
    } else {
      this.setup({
        html: this.html.innerHTML,
        plugins: [],
        ...config,
      });
    }
  }

  setup(defaultConfig) {
    this.html.innerHTML = '';
    this.html.setAttribute('kjuicer-component-root', true);

    this.plugins = ['toolbar', 'self_contained'].concat(defaultConfig.plugins)
      .map(name => pluginFactory(name)).filter(pl => pl);

    /*
    * allow plugins to change default values
    */
    const derivedConf = this.plugins
      .reduce((prevConf, plugin) => (plugin.beforeConfig(prevConf)), defaultConfig);

    this.store = createStore(
      kjuicer,
      { ...initialState, ...derivedConf },
      devtools(),
    );

    this.layer = new Layer();
    this.viewer = new Viewer();

    this.update = this.update.bind(this);
    this.store.subscribe(this.update);
    this.init();
  }

  init() {
    const state = this.store.getState();
    this.layer.init(state);

    this.html.appendChild(this.viewer.html);
    this.viewer.init(state, this.store);

    this.plugins.map(plugin => plugin.init(this.html, state, this.store.dispatch));
  }

  update() {
    const state = this.store.getState();
    this.layer.update(state);
    this.viewer.update(state);

    this.plugins.map(plugin => plugin.update(this.html, state, this.store.dispatch));
  }

  close() {
    const state = this.store.getState();
    this.plugins.map(plugin => plugin.unmount());

    this.html.innerHTML = state.html;
    document.head.removeChild(this.layer.html);
    Object.keys(this).map(key => delete this[key]);
  }

  setHTML(html) {
    this.store.dispatch(actionCreator.setHTML(html));
  }

  goToLevel(level) {
    this.store.dispatch(actionCreator.goToLevel(level));
  }

  toggleVisibility() {
    this.store.dispatch(actionCreator.toggleVisibility());
  }

  toggleSelfContainedMode() {
    this.store.dispatch(actionCreator.toggleSelfContainedMode());
  }

  replaceHighlighters(highlighters) {
    this.store.dispatch(actionCreator.replaceHighlighters(highlighters));
  }
}

window.Kjuicer = App;
